// User Authentication
export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

// IEX api
export const GET_DATA = "GET_DATA";
export const GET_CLOUD_DATA = "GET_CLOUD_DATA";
export const GET_CHART = "GET_CHART";
export const GET_QUOTE = "GET_QUOTE";
export const GET_SYMBOLS = "GET_SYMBOLS";
export const GET_ADVANCED_STATS = "GET_ADVANCED_STATS";
export const GET_KEY_STATS = "GET_KEY_STATS";
export const GET_BALANCE_SHEET = "GET_BALANCE_SHEET";
export const GET_CASH_FLOW = "GET_CASH_FLOW";
export const GET_INCOME_STATEMENT = "GET_INCOME_STATEMENT";
export const GET_INTRADAY_PRICES = "GET_INTRADAY_PRICES";

// News api
export const GET_NEWS = "GET_NEWS"

// Financial Modeling Prep api
export const GET_COMPANY_PROFILE = "GET_COMPANY_PROFILE";


// User data
export const GET_USER_DATA = "GET_USER_DATA";
export const UPDATE_DATA = "UPDATE_DATA";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_FAIL = "UPDATE_FAIL";
export const CLEAR_UPDATE_ERRORS = "CLEAR_UPDATE_ERRORS";

// Search Bar
export const GET_SEARCH_RESULTS = "GET_SEARCH_RESULTS";

// Trade data
export const GET_TRADES = "GET_TRADES";
export const DELETE_TRADE = "DELETE_TRADE";
export const ADD_TRADE = "ADD_TRADE";

// Funds data
export const GET_FUNDS = "GET_FUNDS";
export const ADD_FUNDS = "ADD_FUNDS";
export const UPDATE_FUNDS = "UPDATE_FUNDS";
export const DELETE_FUNDS = "DELETE_FUNDS";
